<template>
  <v-container class="pa-4">
    <v-card v-if="loading && !entiteChargee" class="mx-auto pa-6 mt-6" max-width="500">
      <v-card-text class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </v-card-text>
    </v-card>

    <v-card
      v-if="entiteChargee && !isPaysafeSuccess && !isPaysafeError"
      class="mx-auto pa-6 mt-6"
      max-width="500"
    >
      <v-card-title class="justify-center text-center">
        Compléter votre {{ estEngagement ? 'engagement' : 'don' }}
      </v-card-title>

      <v-card-text>
        <div class="mb-2"><strong>Nom :</strong> {{ entite.prenom }} {{ entite.nom }}</div>

        <template v-if="!estEngagement">
          <div class="mb-2"><strong>Date :</strong> {{ entite.dateDePaiement | shortdate }}</div>
          <div class="mb-2"><strong>Montant :</strong> {{ entite.montantTotal | money }}</div>
          <div v-if="entite.projetsSoutenus" class="mb-2">
            <strong>Projet(s) soutenu(s) :</strong> {{ entite.projetsSoutenus }}
          </div>
        </template>

        <template v-else>
          <div class="mb-2"><strong>Date de début :</strong> {{ entite.dateDebut | shortdate }}</div>
          <div class="mb-2"><strong>Fréquence :</strong> {{ entite.frequence }}</div>
          <div class="mb-2"><strong>Montant par versement :</strong> {{ entite.montantParVersement | money }}</div>
          <div class="mb-2"><strong>Nombre de versements :</strong> {{ entite.nombreDeVersements }}</div>
          <div class="mb-2"><strong>Montant total :</strong> {{ entite.montantTotal | money }}</div>
          <div v-if="entite.projetsSoutenus" class="mb-2">
            <strong>Projet(s) soutenu(s) :</strong> {{ entite.projetsSoutenus }}
          </div>
        </template>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="payNow"
        >
          Compléter votre {{ estEngagement ? 'engagement' : 'don' }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="isPaysafeSuccess" class="mx-auto pa-6 mt-6" max-width="500">
      <v-card-text class="text-center">
        Paiement réussi ! Merci pour votre {{ estEngagement ? 'engagement' : 'don' }}.
      </v-card-text>
    </v-card>

    <v-card v-if="isPaysafeError" class="mx-auto pa-6 mt-6" max-width="500">
      <v-card-text class="text-center">
        Une erreur est survenue :
        <br />
        Erreur {{ error.code }} : {{ error.displayMessage }}
        <br />
        {{ error.detailedMessage }}
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="retry">Réessayer</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import SaisirPaiementPaysafeApi from "@/mixins/services/saisirPaiementPaysafeApi"
import PaysafeModale from "@/mixins/paysafeModale"

const TAB_SAS_ENGAGEMENT_TELEMARKETING = 3400

export default {
  mixins: [SaisirPaiementPaysafeApi, PaysafeModale],

  data() {
    return {
      tab: 0,
      fileId: 0,
      token: "",
      entite: {
        nom: "",
        prenom: "",
        montantTotal: 0,
        dateDePaiement: null,
        dateDebut: null,
        frequence: "",
        montantParVersement: 0,
        nombreDeVersements: 0,
        projetsSoutenus: ""
      },
      entiteChargee: false,
      isPaysafeSuccess: false,
      isPaysafeError: false,
      error: {
        code: "",
        displayMessage: "",
        detailedMessage: ""
      },
      paramsModale: {
        montant: null,
        holderName: null,
        langue: 'fr_CA',
        devise: 'CAD',
        companyName: 'Université de Sherbrooke',
        buttonLabel: "Confirmer",
        displayPaymentMethods: ["Cards"],
        preferredPaymentMethod: "Cards",
        billingAddress: null
      }
    }
  },

  computed: {
    estEngagement() {
      return Number(this.tab) === TAB_SAS_ENGAGEMENT_TELEMARKETING
    }
  },

  mounted() {
    this.tab = Number(this.$route.params.tab) || Number(this.$route.query.tab) || 0
    this.fileId = Number(this.$route.params.fileId) || Number(this.$route.query.fileId) || 0
    this.token = this.$route.query.token || ""

    if (!this.tab || !this.fileId) {
      this.$router.push({ name: "Erreur" })
      return
    }

    this.loadAndSetup()
  },

  methods: {
    loadAndSetup() {
      this.loading = true
      this.loadFileInfos(this.tab, this.fileId, this.token)
        .then((res) => {
          this.entite = { ...this.entite, ...res.data.entite }
          this.entiteChargee = true
        })
        .catch((err) => {
          this.error.code = err.response?.status || err.name
          this.error.displayMessage = err.response?.data?.message || err.message
          this.isPaysafeError = true
        })
        .finally(() => {
          this.loading = false
        })
    },

    payNow() {
      this.showPaysafeModale(
        this.entite.montantTotal,
        `${this.entite.prenom} ${this.entite.nom}`.trim()
      )
    },

    onSuccessPaysafe(token, paymentMethod) {
      this.sendProcessPayment(
        this.tab,
        this.fileId,
        this.token,
        this.entite.montantTotal,
        token,
        paymentMethod
      )
        .then((res) => {
          if (res.data.paiementReussi) {
            this.isPaysafeSuccess = true
          } else {
            this.error.code = res.data.errorCode
            this.error.displayMessage = res.data.errorMessage
            this.isPaysafeError = true
          }
        })
        .catch((err) => {
          this.error.code = err.name
          this.error.displayMessage = err.message
          this.isPaysafeError = true
        })
        .finally(() => {
          this.loading = false
        })
    },

    onFailurePaysafe(errorCode, displayMessage, detailedMessage) {
      this.error.code = errorCode
      this.error.displayMessage = displayMessage
      this.error.detailedMessage = detailedMessage
      this.isPaysafeError = true
      this.loading = false
    },

    retry() {
      this.error = { code: "", displayMessage: "", detailedMessage: "" }
      this.isPaysafeError = false
    }
  }
}
</script>

<style scoped>
</style>
